module.exports = __webpack_public_path__ + "static/media/2-teacher-1.b87e60a9.webp";